export const WebCarouselModuleName = 'Product Carousel';
